import { useState, useEffect } from 'react'
import { Icon } from '@iconify/react'
import FormLoader from '../../../../components/loader/FormLoader'
import Pagination from '../../../../components/pagination/Pagination'
import { get } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import EditConfig from './components/EditConfig'

function PortalConfig() {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)
  const [config, setConfig] = useState({
    data: [],
    pagination: { page: 1, limit: 10, totalPages: 1, totalRecords: 0 },
  })
  function fetchConfigs(page = 1, limit = 10) {
    setLoading(true)
    let url = `super-admin-services?page=${page}&limit=${limit}`
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setConfig({
            data: result.data.services || [],
            pagination: {
              page: result.data.pagination.page,
              limit: result.data.pagination.limit,
              totalPages: result.data.pagination.totalPages,
              totalRecords: result.data.pagination.total,
            },
          })
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  useEffect(() => {
    fetchConfigs()
  }, [])

  const [showCreate, setShowCreate] = useState(false)
  const [selectedZoneData, setSelectedZoneData] = useState(null)
  return (
    <div className='home'>
      {' '}
      <div className='home_tables'>
        <div className='left'>
          {loading ? (
            <FormLoader position='center' />
          ) : (
            <>
              {config.data.length > 0 ? (
                <>
                  <div className='mobile-table'>
                    {config.data.map((item: any, i: number) => (
                      <div
                        className='card'
                        onClick={() => {
                          setSelectedZoneData(item)
                          setShowCreate(true)
                        }}
                        key={item._id}
                      >
                        <div className='flex justify-between row'>
                          <div className='count flex items-center justify-center'>
                            {i + 1}
                          </div>
                          <p> {new Date(item.createdAt).toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Key</h4>
                          <p>{item.key}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Value</h4>
                          <p>{item.value}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Description</h4>
                          <p>{item.description}</p>
                        </div>
                        {/* <div className='row flex justify-between'>
                          <h4>Status</h4>
                          <span
                            className={`chip ${
                              item.isActive ? 'active' : 'inactive'
                            }`}
                          >
                            {item.isActive ? 'Active' : 'Inactive'}
                          </span>
                        </div> */}
                      </div>
                    ))}
                  </div>
                  <table className='desktop-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Key</th>
                        <th>Value</th>
                        <th>Description</th>
                        {/* <th>Status</th> */}
                        <th>Created At</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {config.data.map((item: any, i: number) => (
                        <tr key={item._id}>
                          <td>{i + 1}</td>
                          <td className='count'>{item.key}</td>
                          <td className='count'>{item.value}</td>
                          <td className='count'>{item.description}</td>
                          {/* <td>
                            <span
                              className={`chip ${
                                item.isActive ? 'active' : 'inactive'
                              }`}
                            >
                              {item.isActive ? 'Active' : 'Inactive'}
                            </span>
                          </td> */}
                          <td className='count'>
                            {new Date(item.createdAt).toLocaleString()}
                          </td>
                          <td>
                            <span
                              onClick={() => {
                                setSelectedZoneData(item)
                                setShowCreate(true)
                              }}
                              className='view'
                            >
                              Edit
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={config.pagination.page}
                    totalCount={config.pagination.totalPages}
                    pageSize={config.pagination.limit}
                    onPageChange={(page: number, pageSize: number) => {
                      fetchConfigs(page, pageSize)
                    }}
                  />
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='majesticons:book-line' />
                    <h1>No Admin Services Found</h1>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {showCreate && (
        <EditConfig
          setShowCreate={setShowCreate}
          fetchRates={fetchConfigs}
          selectedZoneData={selectedZoneData}
        />
      )}
    </div>
  )
}

export default PortalConfig
